import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import EditCategoryForm from './category-edit-form';
import BackLink from '../../../../common/back-link/index';
import PageTitle from '../../../../common/page-title/index';
import {getCategory} from '../../../../../actions/categories';

class EditCategory extends Component {
  UNSAFE_componentWillMount() {
    const id = +this.props.match.params.id;
    if (id) {
      this.props.dispatch(getCategory(id));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_category'));
    this.props.dispatch({type: 'CLEAR_EDIT_CATEGORY'});
  }

  render() {
    return (
      <Container fluid className="categories">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/categories"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Add/Edit category
            </PageTitle>
          </Col>
        </Row>
        <EditCategoryForm category={this.props.category}/>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  category: state.categories.category,
  fetched: state.categories.fetched,
  fetching: state.categories.fetching,
});

export default connect(mapStateToProps)(EditCategory);
